import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14.667">
    <path d="M9.333 4h-8A1.334 1.334 0 000 5.333v1.334h10.667V5.333A1.334 1.334 0 009.333 4zm0 4h-8A1.334 1.334 0 000 9.333v1.333h10.667V9.333A1.334 1.334 0 009.333 8zm0 4h-8A1.334 1.334 0 000 13.333v1.333h10.667v-1.333A1.334 1.334 0 009.333 12zm5.334-12h-8a1.334 1.334 0 00-1.334 1.333v1.334H16V1.333A1.334 1.334 0 0014.667 0zm0 4h-3.038A2.639 2.639 0 0112 5.333v1.334h4V5.333A1.334 1.334 0 0014.667 4zm0 8h-3.038A2.639 2.639 0 0112 13.333v1.333h4v-1.333A1.334 1.334 0 0014.667 12zm0-4h-3.038A2.639 2.639 0 0112 9.333v1.333h4V9.333A1.334 1.334 0 0014.667 8z" />
  </svg>
);
